import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { fadeInUp400ms } from '../../../../../@vex/animations/fade-in-up.animation';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { Roles } from 'src/assets/static-data/enums/roles.enum';
import { VexConfigService } from 'src/@vex/config/vex-config.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'vex-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInUp400ms],
  standalone:true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatCheckboxModule,
    RouterLink,
    MatSnackBarModule,
    CommonModule,
    ]
})
export class LoginComponent {

   form: UntypedFormGroup;
   @ViewChild("token") token;
   inputType = 'password';
   visible = false;
   error = new BehaviorSubject<string>(null);
   EMail:any;

   WELCOME_BACK:any;
   EMAIL_REQUIRED:any = "We need an email address to log you in";
   EYE_VISIBILITY :any= "Click the eye to toggle visibility";
   PASSWORD_REQUIRED:any="We need a password to log you in"
   REMEMBER_ME:any="Remember Me";
   FORGET_PASSWORD:any="Forgot Password?";
   WELCOME_BACK_MESSAGE:any="Sign in with your credentials below.";
   Password:any;
   SIGNIN:any;
   isDriverRole:boolean=false;
  constructor(private router: Router,
              private fb: UntypedFormBuilder,
              private cd: ChangeDetectorRef,
              private snackbar: MatSnackBar,
              private authService: AuthService,
              private userService: UserService,
              private configService: VexConfigService
  ) {}

  ngOnInit() {

    var lang = localStorage.getItem('lang');
    if(lang == "ar")
      {
        this.EMail = "البريد الإلكتروني";
        this.WELCOME_BACK = "مرحبا بعودتك!";
        this.WELCOME_BACK_MESSAGE = "سجل الدخول باستخدام بيانات الاعتماد الخاصة بك أدناه";
        this.EMAIL_REQUIRED = "نحتاج إلى عنوان بريد إلكتروني لتسجيل دخولك";
        this.EYE_VISIBILITY = "انقر فوق العين لتبديل الرؤية";
        this.PASSWORD_REQUIRED = "نحتاج إلى كلمة مرور لتسجيل دخولك";
        this.REMEMBER_ME = "تذكرني";
        this.FORGET_PASSWORD = "نسيت كلمة المرور؟";
        this.Password = "كلمة المرور";
        this.SIGNIN = "تسجيل الدخول";

      }
    else{
      this.EMail = "E-Mail";
      this.WELCOME_BACK = "Welcome Back!";
      this.WELCOME_BACK_MESSAGE = "Sign in with your credentials below.";
      this.EMAIL_REQUIRED = "We need an email address to log you in";
      this.EYE_VISIBILITY = "Click the eye to toggle visibility";
      this.PASSWORD_REQUIRED = "We need a password to log you in";
      this.REMEMBER_ME = "Remember Me";
      this.FORGET_PASSWORD = "Forgot Password?";
      this.Password = "Password";
      this.SIGNIN = "Sign In";
    }


    this.form = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    this.isDriverRole=this.authService.isDriverUserValue;
  }

  get f() { return this.form.controls; }


  send() {
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    } else {
        this.authService.login(this.f.email.value, this.f.password.value, this.token.nativeElement.value)
          .subscribe(
          {
            next: async _ => {
              // // debugger;
              const userId = this.authService.currentUserValue?.id;
              let lang = localStorage.getItem("lang");
              if(lang){
                this.configService.updateConfig({
                  direction: lang == "ar" ? 'rtl' : 'ltr'
                });
              } else {
                this.configService.updateConfig({
                  direction: "rtl"
                });
              }              
              if(this.isDriverRole)
              {
                this.router.navigate(['/driver-trips'])
                location.reload();
              } 

             else {
                this.router.navigate(['/']);
                location.reload();
             }
            },
            error: error => {
              // debugger
              if (error instanceof HttpErrorResponse) {
                // This is an HTTP error
                this.error.next(`Error: ${error.error.message}`);
              } else {
                // This is a custom or thrown exception
                this.error.next(error);
              }
            }
          });
      }
  }  
  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  // form = this.form = this.fb.group({
  //       email: ['', Validators.required],
  //       password: ['', Validators.required],
  //     });

  // inputType = 'password';
  // visible = false;

  // constructor(
  //   private router: Router,
  //   private fb: FormBuilder,
  //   private cd: ChangeDetectorRef,
  //   private snackbar: MatSnackBar
  // ) {}

  // send() {
  //   this.router.navigate(['/']);
  //   this.snackbar.open(
  //     "Lucky you! Looks like you didn't need a password or email address! For a real application we provide validators to prevent this. ;)",
  //     'THANKS',
  //     {
  //       duration: 10000
  //     }
  //   );
  // }

  // toggleVisibility() {
  //   if (this.visible) {
  //     this.inputType = 'password';
  //     this.visible = false;
  //     this.cd.markForCheck();
  //   } else {
  //     this.inputType = 'text';
  //     this.visible = true;
  //     this.cd.markForCheck();
  //   }
  // }
}
